// src/views/Liquidacion/ConfirmarUltimaLiquidacionActiva.jsx
import React from "react";
import EjecutarProceso from "../../EstadosFlujos/Procesos/EjecutarProceso";

export default function ConfirmarUltimaLiquidacionActiva({ onRedirect }) {
  return (
    <EjecutarProceso
      procesoId={3}
      titulo="Confirmar Última Liquidación Activa"
      redirectView="ejecucionLiquidaciones" // ✅ SIN SLASH
      onRedirect={onRedirect}
    />
  );
}
